/* eslint-disable @next/next/no-img-element */
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import CustomButton from "../ratl/utility/CustonButton";
import { useFloat } from "@/lib";
import { RT_DEMO_CAL_URL, RT_STUDIO_RIL } from "@/data";
import { useRouter } from "next/navigation";

const PricingBody = ({
  type,
  title,
  subTitle,
  price,
  interval,
  buttonText,
  pricingHeader,
  features,
}: {
  type: string;
  title: string;
  subTitle: string;
  price: string;
  interval: string;
  buttonText: string;
  pricingHeader: string;
  features: string[];
}) => {
  const { float, handleFloat } = useFloat([false, false]);
  const router = useRouter();
  return (
    <div
      className={`rounded-[12px] bg-white/85`}
      style={{
        boxShadow:
          "0px 1px 2px 0px rgba(95, 74, 46, 0.08), 0px 4px 6px 0px rgba(95, 74, 46, 0.04), 0px 24px 40px -16px rgba(104, 75, 37, 0.08)",
      }}
    >
      <div
        className={`flex flex-col md:flex-row w-fit md:px-14 md:py-10 p-5 h-fit rounded-[20px] font-inter text-black gap-12 `}
      >
        <div className="flex flex-col  md:w-[498px] w-[295px] gap-6">
          {/* <div className="">
            <Badge
              type={type}
              className="font-semibold uppercase leading-[12px] border-rt-grey-t4"
            />
          </div> */}
          <div>
            <h1 className="text-xl font-medium">{title}</h1>
          </div>
          <div className="w-[372px] text-wrap">
            <p className="text-sm max-w-[295px] md:max-w-[450px]">{subTitle}</p>
          </div>
          <div className="text-5xl">
            <p>{price}</p>
          </div>
          <div>
            <p>{interval}</p>
          </div>
          <div>
            {/* <button
          className={`py-2 px-4 w-fit h-11 font-medium rounded-[22px] text-sm ${
            type == "Starter"
              ? "bg-[#353343] text-white "
              : "text-rt-black-t1 bg-white/80 "
          } hover:bg-opacity-80`}
        >
          {buttonText}
        </button> */}
            {type == "Starter" ? (
              <CustomButton
                text={buttonText}
                animationRequired={false}
                bgType={"transparent"}
                onMouseEnter={() => handleFloat(true, 1)}
                onMouseLeave={() => handleFloat(false, 1)}
                controller={float[1]}
                btnSize="small"
                onClick={() => window.open(RT_STUDIO_RIL, "_blank")}
                showMobile={true}
              />
            ) : (
              <div className="w-fit">
                <CustomButton
                  text={buttonText}
                  animationRequired={false}
                  bgType={"solid"}
                  onMouseEnter={() => handleFloat(true, 1)}
                  onMouseLeave={() => handleFloat(false, 1)}
                  controller={float[1]}
                  btnSize="small"
                  onClick={() => {
                    window.location.href = RT_DEMO_CAL_URL;
                  }}
                  className="px-4 py-2 text-sm transition w-fit rounded-lg border-solid border-[1px] hover:bg-transparent hover:text-black hover:border-solid hover:border-black hover:border-[1px]"
                  showMobile={true}
                  ct="demo"
                />
              </div>
            )}
          </div>
          {type == "Starter" && (
            <div>
              <p>What's Included :</p>
            </div>
          )}
        </div>

        <div className="flex flex-col gap-6">
          <Features features={features} type={type} />
        </div>
      </div>
    </div>
  );
};

export default PricingBody;

export const Badge = ({
  type,
  className,
  arrow,
}: {
  type: string;
  className?: string;
  arrow?: boolean;
}) => {
  return (
    <button
      className={cn(
        "px-3 py-1 text-[11px] text-card-description font-normal w-fit rounded-lg border-[1px] border-solid border-[rgba(255,255,255,0.15)] bg-white/5 backdrop-filter backdrop-blur-[1.5px] flex justify-center items-center gap-1 font-inter cursor-default",
        className
      )}
    >
      {type} {arrow && <ChevronRight className="w-5 h-5" />}
    </button>
  );
};

const Features = ({ features, type }: { features: string[]; type: string }) => {
  return (
    <div className="flex flex-col gap-5">
      {features.map((feature) => {
        return (
          <div className="flex justify-start gap-2">
            <div
              className={`rounded-full w-5 h-5 p-1 flex justify-center items-center ${
                type == "Starter" ? "bg-[#8B8994]" : "bg-[#B8B8B8]"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="10"
                viewBox="0 0 12 10"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.3314 1.29842C11.5145 1.48148 11.5145 1.77828 11.3314 1.96134L4.45646 8.83633C4.36856 8.92431 4.24932 8.97366 4.125 8.97366C4.00068 8.97366 3.88145 8.92431 3.79355 8.83633L0.668543 5.71134C0.485485 5.52828 0.485486 5.23148 0.668545 5.04843C0.851604 4.86537 1.1484 4.86537 1.33146 5.04843L4.125 7.84199L10.6685 1.29843C10.8516 1.11537 11.1484 1.11537 11.3314 1.29842Z"
                  fill="#ffffff"
                  stroke="#ffffff"
                />
              </svg>
            </div>
            <p>{feature}</p>
          </div>
        );
      })}
    </div>
  );
};
